// extracted by mini-css-extract-plugin
export default {"sub_container_sub":"SubLayout_sub_container_sub__WxDe8"};